import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from '@/i18n/messages/en'
import dateTimeFormats from '@/i18n/messages/date-time-formats'
import axios from 'axios';
import locale from 'element-ui/lib/locale'
import { locale_mapping_UI } from '@/helpers/languages'
import { locale_lang } from "@/helpers/languages";
Vue.use(VueI18n);

export const i18n = new VueI18n({
  fallbackLocale: 'en',
  messages: {
    en,
  },
  dateTimeFormats,
  silentTranslationWarn: true
})

export default i18n;

const loadedLanguages = ['en'] // our default language that is preloaded

function setI18nLanguage (lang) {
  i18n.locale = lang
  axios.defaults.headers.common['Accept-Language'] = lang
  document.querySelector('html').setAttribute('lang', lang)
  localStorage.setItem('curr_language', lang);
  locale.use(locale_mapping_UI[lang])
  return lang
}

export function loadLanguageAsync(lang) {
  // If the same language
  if (i18n.locale === lang) {
    return Promise.resolve(setI18nLanguage(lang))
  }

  // If the language was already loaded
  if (loadedLanguages.includes(lang)) {
    return Promise.resolve(setI18nLanguage(lang))
  }

  // If the language hasn't been loaded yet
  return import(/* webpackChunkName: "lang-[request]" */ `@/i18n/messages/${lang}.js`)
    .then(messages => {
      i18n.setLocaleMessage(lang, messages.default)
      loadedLanguages.push(lang)
      return setI18nLanguage(lang)
    })
    .catch(() => setI18nLanguage('en'))
}

// Try to load browsers' language, defaults to 'en'
function getUserCountryIP() {
  try {
    axios.get('https://elsaspeak.com/api/get-ip').then(response => {
      let country = response.data['country'] || "EN"
      const locale = locale_lang.find(lang => lang.country_code === country.toLowerCase())
      if (!locale) {
        loadLanguageAsync('en')
      } else {
        loadLanguageAsync(localStorage.getItem('curr_language') || locale.id)
      }
    })
  } catch (error) {
    loadLanguageAsync('en')
  }
}

getUserCountryIP()
